<template>
  <div>
    <v-wait :for="loaderId" >
      <HalfCircleSpinner slot="waiting" />
      <template slot="waiting">
        <div class="spinner-message my-3 text-center">
          Loading the data...
        </div>
      </template>
      <b-row>
        <b-col sm="12" md="6" xl="4">
          <strong class="body-copy-font phairify-color-teal">Active Members:</strong>
          <span class="body-copy-font phairify-color-grey"> {{ usersActive }}</span>
        </b-col>
        <b-col sm="12" md="6" xl="4">
          <strong class="body-copy-font phairify-color-teal">Disabled Members:</strong>
          <span class="body-copy-font phairify-color-grey"> {{ usersDisabled }}</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" xl="4">
          <strong class="body-copy-font phairify-color-teal">Members Not Sent Registration Email:</strong>
          <span class="body-copy-font phairify-color-grey"> {{ membersNotSentRegEmail }}</span>
        </b-col>
        <b-col sm="12" md="6" xl="4">
          <strong class="body-copy-font phairify-color-teal">Members Sent Email But Not Registered:</strong>
          <span class="body-copy-font phairify-color-grey"> {{ membersNotRegistered }}</span>
        </b-col>
      </b-row>
    </v-wait>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import Api from '@/providers/Api';
export default {
  name: 'Statistics',
  components: {
    HalfCircleSpinner,
  },
  props: {
    id: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      statistics: null,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
    usersActive() {
      return this.statistics ? this.statistics.users.active : 'Not present';
    },
    usersDisabled() {
      return this.statistics ? this.statistics.users.disabled : 'Not present';
    },
    membersNotSentRegEmail() {
      return this.statistics ? this.statistics.members.notSentRegEmail : 'Not present';
    },
    membersNotRegistered() {
      return this.statistics ? this.statistics.members.notRegistered : 'Not present';
    },
  },
  methods: {
    getData: async function () {
      this.$wait.start(this.loaderId);
      try {
        if (!this.id) {
          this.statistics = await Api.mssAdminGetStatisticsOfMembers();
        } else {
          this.statistics = await Api.getSocietyStatisticsOfMembers(this.id);
        }
      } catch (error) {
        const data = error.response.data;
        this.$toasted.error(data.message, { duration: 3000 });
      }
      this.$wait.end(this.loaderId);
    },
  },
};
</script>

<style scoped></style>
